module.exports = __webpack_public_path__ + "static/media/total-order-icon.4d78f097.svg";